import React from "react";
import PropTypes from "prop-types";
import { Select as AntSelect } from "antd";
import { UiSearchSelect } from "./SearchSelect.style";

/**
 * 可輸入關鍵字篩選的下拉選單
 * options 格式與 common-components 的 Select 相同：[{ name, value }]
 * 關鍵字會同時比對 name 與 value（例如題型名稱與題型代碼）
 */

const defaultFilterOption = (input, option) => {
	const keyword = input.trim().toLowerCase();
	if (!keyword) return true;
	return (
		String(option.label ?? "")
			.toLowerCase()
			.includes(keyword) ||
		String(option.value ?? "")
			.toLowerCase()
			.includes(keyword)
	);
};

const SearchSelect = ({
	options = [],
	className,
	label,
	message,
	value,
	defaultValue,
	onChange,
	onClear,
	disabled,
	placeholder,
	row = false,
	allowClear = true,
	notFoundContent = "查無符合的選項",
	filterOption = defaultFilterOption,
	getPopupContainer = () => document.getElementById("root"),
	dropdownStyle,
}) => {
	const antOptions = options.map((option) => ({
		label: option.name,
		value: option.value,
	}));

	return (
		<UiSearchSelect row={row} className={className}>
			{label && <div className="label">{label}</div>}
			<AntSelect
				showSearch
				options={antOptions}
				filterOption={filterOption}
				value={value}
				defaultValue={defaultValue}
				onChange={onChange}
				onClear={onClear}
				disabled={disabled}
				allowClear={allowClear}
				placeholder={placeholder}
				notFoundContent={notFoundContent}
				getPopupContainer={getPopupContainer}
				dropdownStyle={dropdownStyle}
			/>
			{message && (
				<div className="message">
					<i className="material-icons" style={{ fontSize: "20px" }}>
						cancel
					</i>
					{message}
				</div>
			)}
		</UiSearchSelect>
	);
};

export default SearchSelect;

SearchSelect.propTypes = {
	options: PropTypes.array,
	className: PropTypes.string,
	label: PropTypes.string,
	message: PropTypes.string,
	value: PropTypes.string,
	defaultValue: PropTypes.string,
	onChange: PropTypes.func,
	onClear: PropTypes.func,
	disabled: PropTypes.bool,
	placeholder: PropTypes.string,
	row: PropTypes.bool,
	allowClear: PropTypes.bool,
	notFoundContent: PropTypes.node,
	filterOption: PropTypes.func,
	getPopupContainer: PropTypes.func,
	dropdownStyle: PropTypes.object,
};
